module.exports = __webpack_public_path__ + "vue/img/person1.7c5daa9b.png";